<template>
<m-pageframe
    :title="title"
>
<v-container>


<m-inbox-email-log-entry-card
    v-for="(item, index) in search_results"
    :key="index"
    :value="item"
/>


</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            inbox_metadata: null,
            search_results: null,
        }
    },

    mounted () 
    {  
        this.$rc.rest(
            'GET: /api/v1/inboxes/:inbox_id',
        
            {
                'inbox_id': this.$route.params.inbox_id,
            },
        
            (data) => {
                this.inbox_metadata = data;
            },
        
            () => {
                this.$rc.alert('Error','Unable to get inbox information');
            },
        );

        this.$rc.showSpinner();
        
        this.$rc.listInboxEmail(
            {
                'inbox_id' : this.$route.params.inbox_id,
            },
        
            (data) => {
                this.$rc.hideSpinner();

                this.search_results = data.results;
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to complete API call');
            },
        );
    },

    computed: {
        title() {
            if ( this.inbox_metadata == null )
                return 'Inbox Email Log';

            return 'Inbox Email Log: '+this.inbox_metadata.internal_label;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>